/* Native, reversible scroll choreography for the approved Le Rose scene. */
(() => {
  const hero = document.querySelector('.rose-campaign-hero');
  const stage = hero?.querySelector('.rose-campaign-stage');
  const scene = hero?.querySelector('.rose-campaign-scene');
  if (!hero || !stage || !scene) return;

  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const header = document.querySelector('#site-header');
  const clamp = value => Math.max(0, Math.min(1, value));
  let raf = 0, recovery = 0, previousTime = 0, current = 0, initialized = false;
  let lastReduced, lastHeader = -1, lastHeight = -1;

  function send(type, value) {
    try { scene.contentWindow?.postMessage({ type, ...value }, location.origin); }
    catch { /* The image fallback remains available while the scene loads. */ }
  }

  function draw(time = performance.now()) {
    raf = 0;
    clearTimeout(recovery);
    recovery = 0;
    const reduced = preference.matches;
    hero.classList.toggle('is-reduced', reduced);
    const top = Math.round(Math.max(0, Math.min(innerHeight * .4, header?.getBoundingClientRect().bottom || 0)));
    const height = Math.max(1, innerHeight - top);
    if (top !== lastHeader) { hero.style.setProperty('--rose-scene-header', `${top}px`); lastHeader = top; }
    if (height !== lastHeight) { hero.style.setProperty('--rose-stage-height', `${height}px`); lastHeight = height; }
    const rect = hero.getBoundingClientRect();
    const travel = Math.max(1, hero.offsetHeight - stage.offsetHeight);
    const scrollProgress = clamp((top - rect.top) / travel);
    // The last part of the pin gives the assembled product a short, quiet hold.
    const target = reduced ? .75 : clamp(scrollProgress / .88) * .75;
    const elapsed = previousTime ? Math.min(64, time - previousTime) : 16;
    previousTime = time;
    const offscreen = rect.bottom <= top || rect.top >= innerHeight;
    if (!initialized || reduced || offscreen) { current = target; initialized = true; }
    else current += (target - current) * (1 - Math.exp(-elapsed / 75));
    const moving = Math.abs(target - current) > .0001;
    if (!moving) current = target;
    if (reduced !== lastReduced) { send('ose:reduced-motion', { enabled: reduced }); lastReduced = reduced; }
    send('ose:progress', { progress: current });
    hero.dataset.progress = (current / .75).toFixed(4);
    hero.dataset.scrollProgress = scrollProgress.toFixed(4);
    if (moving && !document.hidden) queue();
  }

  function queue() {
    if (raf || document.hidden) return;
    raf = requestAnimationFrame(draw);
    // Recover a paused frame after an iframe lifecycle or background-tab change.
    recovery = setTimeout(() => { cancelAnimationFrame(raf); raf = 0; draw(); }, 120);
  }
  function resume() {
    cancelAnimationFrame(raf); clearTimeout(recovery);
    raf = recovery = previousTime = 0;
    lastReduced = undefined;
    queue();
  }
  scene.addEventListener('load', resume);
  window.addEventListener('message', event => {
    if (event.source === scene.contentWindow && event.origin === location.origin && event.data?.type === 'ose:ready') resume();
  });
  document.addEventListener('scroll', queue, { passive: true, capture: true });
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', resume, { passive: true });
  window.addEventListener('pageshow', resume);
  document.addEventListener('visibilitychange', resume);
  preference.addEventListener('change', resume);
  const observer = window.ResizeObserver ? new ResizeObserver(queue) : null;
  observer?.observe(stage); if (header) observer?.observe(header);
  queue();
})();
